// @flow
import React from 'react';
import BoardCreateModal from 'app/common/react/components/profile/ProfileBoards/BoardCreateModal';
import i18n from 'app/common/lib/i18n';
import Testable from 'app/common/react/ui/Testable';
import withAuthenticatedAction from 'app/common/react/components/limitedLogin/withAuthenticatedAction';
import { track } from 'app/common/lib/react/analytics';
import type { BoardPrivacy, ProfileBoard } from 'app/packages/pinterest-flow-types/board';
import {
  getCardWidth,
  getCardHeight,
  type ProfileBoardCardLayout,
} from 'app/common/react/components/profile/ProfileBoardCard/layout';
import { Box, Card, Icon, Text, Touchable } from 'gestalt';

const ADD_CIRCLE_ICON_SIZE = 40;

type Props = {
  // $FlowFixMe Flow v0.104.0 upgrade supression.
  authAction: *,
  cardHeight: number,
  cardWidth: number,
  layout: ProfileBoardCardLayout,
  onBoardCreate: (board: ProfileBoard) => void,
  privacy: BoardPrivacy,
};

type State = {
  isCreateModalOpen: boolean,
};

export class ProfileBoardCreateCard extends React.Component<Props, State> {
  state = {
    isCreateModalOpen: false,
  };

  get createText() {
    const { privacy } = this.props;
    if (privacy === 'secret') {
      return (
        i18n._('Create secret board') || i18n._('Create secret board', 'create secret board header')
      );
    }
    if (privacy === 'protected') {
      return (
        i18n._('Create protected board') ||
        i18n._('Create protected board', 'create protected board header')
      );
    }
    return i18n._('Create board') || i18n._('Create board', 'create board header');
  }

  handleCreateClick = this.props.authAction(() => {
    this.setState({ isCreateModalOpen: true });
    track(PCONST.thrift.EventType.CLICK, {
      component: PCONST.thrift.ComponentType.FLOWED_BOARD,
      element: PCONST.thrift.ElementType.CREATE_BOARD_BUTTON,
      view: PCONST.thrift.ViewType.USER,
    });
  });

  handleHide = () => {
    this.setState({ isCreateModalOpen: false });
  };

  render() {
    const { onBoardCreate, layout, privacy } = this.props;
    const { isCreateModalOpen } = this.state;

    return (
      <Testable id="createBoardCard">
        <Touchable fullWidth={false} onTouch={this.handleCreateClick} shape="rounded">
          <Card>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              color="lightGray"
              shape="rounded"
              width={getCardWidth(layout)}
              height={getCardHeight(layout)}
              fit
            >
              <Box
                color="white"
                height={ADD_CIRCLE_ICON_SIZE}
                width={ADD_CIRCLE_ICON_SIZE}
                shape="circle"
              >
                <Icon
                  accessibilityLabel=""
                  color="red"
                  icon="add-circle"
                  size={ADD_CIRCLE_ICON_SIZE}
                />
              </Box>
            </Box>
            <Box paddingX={2} paddingY={3}>
              <Text color="gray" size="lg" weight="bold">
                {this.createText}
              </Text>
            </Box>
          </Card>
        </Touchable>
        {isCreateModalOpen && (
          <BoardCreateModal
            onBoardCreate={onBoardCreate}
            onClose={this.handleHide}
            privacy={privacy}
          />
        )}
      </Testable>
    );
  }
}

// $FlowFixMe: new errors found from flow 0.96 upgrade
export default withAuthenticatedAction(ProfileBoardCreateCard);
